import { html as $, nothing as w } from '../../../../../node_modules/lit-html/lit-html.js';
import { unsafeHTML as o } from '../../../../../node_modules/lit-html/directives/unsafe-html.js';

const handleCardClick = (e, href, target) => {
    const targetElement = e.target;
    if (targetElement.closest('.product-preview-card__description')) {
        return;
    }
    if (targetElement.tagName === 'A' || targetElement.closest('a')) {
        return;
    }
    if (target === '_blank') {
        window.open(href, '_blank');
    }
    else {
        window.location.href = href;
    }
};
const renderProductPreviewCard = (card, index, total, rtl = false) => {
    const cardId = `product-card-${card.id || index}`;
    const titleId = `${cardId}-title`;
    const descId = `${cardId}-desc`;
    const direction = rtl ? 'rtl' : 'ltr';
    const ariaDescribedBy = card.description ? descId : undefined;
    const imageAlt = card.imageAltText || '';
    const linkTarget = card.target || '_self';
    const slideLabel = `${index + 1} of ${total}`;
    const descriptionTemplate = card.description
        ? $ `<p id="${descId}" class="product-preview-card__description">${o(card.description)}</p>`
        : w;
    return $ `<article class="product-preview-card swiper-slide" id="${cardId}" data-card-index="${index}" data-card-id="${card.id}" data-href="${card.href}" aria-roledescription="slide" aria-label="${slideLabel}" aria-labelledby="${titleId}" aria-describedby="${ariaDescribedBy}" dir="${direction}" tabindex="0" @click="${(e) => handleCardClick(e, card.href, linkTarget)}" @keydown="${(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleCardClick(e, card.href, linkTarget);
        }
    }}"><div class="product-preview-card__container"><div class="product-preview-card__image-wrapper"><img class="product-preview-card__image" src="${card.imageUrl}" alt="${imageAlt}" loading="lazy"></div><div class="product-preview-card__content"><h3 id="${titleId}" class="product-preview-card__title"><a href="${card.href}" target="${linkTarget}" aria-describedby="${ariaDescribedBy}" dir="${direction}" tabindex="-1">${o(card.title)}</a></h3>${descriptionTemplate}</div></div></article>`;
};

export { renderProductPreviewCard };
